/**
 * Atalho discreto pro painel do Sentry — só renderiza pra superusers.
 *
 * Motivação: Sentry só serve se a gente abre. Ter um botão no header
 * reduz fricção de "clicar uma vez por semana".
 *
 * URL do projeto vem de `VITE_SENTRY_DASHBOARD_URL` (opcional). Se a
 * env não estiver definida, cai num link genérico `sentry.io` — o
 * usuário ainda chega no painel certo após o login.
 */

import { useAuth } from '../../context/auth'
import { Icon } from '@/design-system/atoms/Icon'

const SENTRY_DASHBOARD_URL =
  (import.meta.env.VITE_SENTRY_DASHBOARD_URL as string | undefined) ||
  'https://sentry.io/organizations/'

export function SentryShortcut() {
  const { user } = useAuth()
  if (!user?.is_superuser) return null

  return (
    <a
      href={SENTRY_DASHBOARD_URL}
      target="_blank"
      rel="noopener noreferrer"
      title="Abrir painel do Sentry (erros em tempo real)"
      aria-label="Abrir painel do Sentry"
      className="inline-flex items-center justify-center h-10 w-10 lg:h-11 lg:w-11 rounded-lg border border-gray-200 dark:border-gray-800 text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
    >
      <Icon name="alert-octagon" size={20} />
    </a>
  )
}
